import { HttpContext } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RequestConfig } from "@webapp/core/abstracts/models/request-config.model";
import { BaseFacade } from "@webapp/core/abstracts/services/base-facade.service";
import { GTMHUB_ADDITIONAL_PARAMS } from "@webapp/core/http/interceptors/track-data.interceptor";
import { Reaction, ReactionDTO } from "../models/reactions.models";
import { ReactionsApiService } from "./reactions-api.service";
import { ReactionsState } from "./reactions-state.service";

@Injectable({
  providedIn: "any",
})
export class ReactionsFacade extends BaseFacade<Reaction, ReactionDTO, ReactionsState, ReactionsApiService> {
  constructor(state: ReactionsState, api: ReactionsApiService) {
    super(state, api);
  }

  public createReaction$(reaction: ReactionDTO, { isReactionOnGif } = { isReactionOnGif: false }): Observable<Reaction> {
    const gtmhubAdditionalParams = {
      reactionOnGif: isReactionOnGif,
    };

    const requestConfig = {
      ...new RequestConfig(),
      context: new HttpContext().set(GTMHUB_ADDITIONAL_PARAMS, gtmhubAdditionalParams),
    };

    return this.apiService.post$(reaction, requestConfig);
  }

  public deleteReaction$(reactionName: string, targetId: string): Observable<void> {
    const config = {
      ...new RequestConfig(),
      url: this.apiService.getDeleteReactionEndpoint(reactionName, targetId),
    };

    return this.apiService.delete$(reactionName, config);
  }
}
